export const ROLE_SUPERADMIN = 1;
export const ROLE_ADMINISTRATOR = 2;
export const ROLE_HOTEL_ADMIN = 3;
export const ROLE_HOTEL_EMPLOYEE = 4;
export const ROLE_PUBLIC = 5;

export const ROLE_STRUCTURE = [
    {
        id: ROLE_ADMINISTRATOR,
        description: "Administrator",
        type: 'role',
        children: null
    },
    {
        id: "stakeholder",
        description: "Stakeholders",
        type: 'parent',
        children: [
            {
                id: "hoteliers",
                description: "Hoteliers",
                type: 'parent',
                children: [
                    {
                        id: ROLE_HOTEL_ADMIN,
                        description: "Hotel Admin",
                        type: 'role',
                        children: null
                    },
                    {
                        id: ROLE_HOTEL_EMPLOYEE,
                        description: "Hotel Employee",
                        type: 'role',
                        children: null
                    }
                ]
            },
            {
                id: "#",
                description: "Other Registered Tourism Accommodation Premises",
                type: 'disabled',
                children: null
            },
            {
                id: "#",
                description: "Travel Agents",
                type: 'disabled',
                children: null
            },
            {
                id: "#",
                description: "Tourism Service Providers",
                type: 'disabled',
                children: null
            },
            {
                id: "#",
                description: "Places of Interests",
                type: 'disabled',
                children: null
            }
        ]
    },
    {
        id: ROLE_PUBLIC,
        description: "Public",
        type: 'role',
        children: null
    },
];
